import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { APP_BASE_HREF, DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpBackend, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from 'src/environments/environment';
import { loadNavbar } from './_shared/loader';
import { HttpErrorInterceptor } from './_services/http-error.interceptor';
import { RequestGoodOfficesServicesComponent } from './pages/request-good-offices-services/request-good-offices-services.component';
import { RequestMediationComponent } from './pages/request-mediation/request-mediation.component';
import { UnilateralRequestMediationComponent } from './pages/unilateral-request-mediation/unilateral-request-mediation.component';
import { RequestArbitrationComponent } from './pages/request-arbitration/request-arbitration.component';
import { ExpeditedArbitrationComponent } from './pages/expedited-arbitration/expedited-arbitration.component';
import { AdrYoungRegistrationComponent } from './pages/adryoung/registration.component';
import { WipoMcstDecisionTreeComponent } from './pages/wipo-mcst-decision-tree/wipo-mcst-decision-tree.component';
import { WipoMcstIncludeDisputeRsltComponent } from './pages/wipo-mcst-decision-tree/wipo-mcst-include-dispute-resolution';
import { WipoMcstIncludeDisputeRelatedContractComponent } from './pages/wipo-mcst-decision-tree/wipo-mcst-dispute-related-contract';
import { LoaderComponent } from './loader/loader.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { HomeComponent } from './pages/home/home.component';
import { WipoAuthService } from './_services/wipo-auth.service';
import { LoaderService } from './_services/loader.service';
import { ContractComponent } from './pages/wipo-mcst-decision-tree/contract/contract.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader'
import { registerLocale } from '@wipo/w-angular/primeng';
import { WcommonModule } from './_shared/wcommon.module';
import { AuthInterceptor } from './_services/auth.interceptor';

import localeEs from '@angular/common/locales/es';
// import localeAr from '@angular/common/locales/ar';
import localeFr from '@angular/common/locales/fr';
import localeZh from '@angular/common/locales/zh';
import localeRu from '@angular/common/locales/ru';
import localeKo from '@angular/common/locales/ko';
import localePt from '@angular/common/locales/pt';
import localeSw from '@angular/common/locales/sw';
import localeTh from '@angular/common/locales/th';
import { UnilateralExpertDeterminationComponent } from './pages/unilateral-expert-determination/unilateral-expert-determination.component';
import { ExpertDeterminationComponent } from './pages/expert-determination/expert-determination.component';
import { NoticeOfUnauthorizedUseComponent } from './pages/notice-of-unauthorized-use/notice-of-unauthorized-use.component';


registerLocale(localeEs);
// registerLocale(localeAr);
registerLocale(localeFr);
registerLocale(localeZh);
registerLocale(localeRu);
registerLocale(localeKo);
registerLocale(localePt);
registerLocale(localeSw);
registerLocale(localeTh);


@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        WcommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpBackend]
            }
        }),
        OAuthModule.forRoot({
            resourceServer: {
                allowedUrls: [
                    // SDDS-2723: no bare `/api/v1` prefixes here. angular-oauth2-oidc matches
                    // by prefix, so a bare `/api/v1` entry also attaches the user's bearer
                    // token to `/api/v1/public/**`, whose endpoints reject a present-but-invalid
                    // token instead of falling back to reCAPTCHA. AuthInterceptor strips the
                    // header as a second guard. The `/api/v1/offices` and `/api/offices` entries
                    // further down are dead (no UI code builds those URLs) but left untouched.
                    'http://local.wipo.int:4400/api/v1/internal',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal',
                    'https://adr.wipo.int/api/v1/internal',
                    'http://local.wipo.int:4400/api/v1/internal/dcti/request',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal/dcti/request',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal/dcti/request',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal/dcti/request',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/dcti/request',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/dcti/request',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/dcti/request',
                    'https://adr.wipo.int/api/v1/internal/dcti/request',
                    'http://local.wipo.int:4400/api/v1/internal/dcti/answer',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal/dcti/answer',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal/dcti/answer',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal/dcti/answer',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/dcti/answer',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/dcti/answer',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/dcti/answer',
                    'https://adr.wipo.int/api/v1/internal/dcti/answer',
                    'http://local.wipo.int:4400/api/v1/internal/dcti/statement-of-acceptance',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal/dcti/statement-of-acceptance',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal/dcti/statement-of-acceptance',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal/dcti/statement-of-acceptance',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/dcti/statement-of-acceptance',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/dcti/statement-of-acceptance',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/dcti/statement-of-acceptance',
                    'https://adr.wipo.int/api/v1/internal/dcti/statement-of-acceptance',
                    'http://local.wipo.int:4400/api/v1/internal/meetings',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal/meetings',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal/meetings',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal/meetings',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/meetings',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/meetings',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/meetings',
                    'https://adr.wipo.int/api/v1/internal/meetings',
                    'http://local.wipo.int:4400/api/v1/internal/indautor',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal/indautor',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal/indautor',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal/indautor',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/indautor',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/indautor',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/indautor',
                    'https://adr.wipo.int/api/v1/internal/indautor',
                    'http://local.wipo.int:4400/api/v1/internal/dnda',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/internal/dnda',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/internal/dnda',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/internal/dnda',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/dnda',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/dnda',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/dnda',
                    'https://adr.wipo.int/api/v1/internal/dnda',
                    'http://local.wipo.int:4400/api/v1/offices',
                    'https://www3dev.wipo.int/amc-forms-rest/api/v1/offices',
                    'https://www3-test.wipo.int/amc-forms-rest/api/v1/offices',
                    'https://www3.wipo.int/amc-forms-rest/api/v1/offices',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/v1/internal/offices',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/v1/internal/offices',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/v1/internal/offices',
                    'https://adr.wipo.int/api/v1/internal/offices',
                    'http://local.wipo.int:4400/api/offices',
                    'https://www3dev.wipo.int/amc-forms-rest/api/offices',
                    'https://www3-test.wipo.int/amc-forms-rest/api/offices',
                    'https://www3.wipo.int/amc-forms-rest/api/offices',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/api/offices',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/api/offices',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/api/offices',
                    'https://adr.wipo.int/api/offices',
                    'http://local.wipo.int:4400/indautor',
                    'https://www3dev.wipo.int/amc-forms-rest/indautor',
                    'https://www3-test.wipo.int/amc-forms-rest/indautor',
                    'https://www3.wipo.int/amc-forms-rest/indautor',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/indautor',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/indautor',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/indautor',
                    'https://adr.wipo.int/indautor',
                    'http://local.wipo.int:4400/dnda',
                    'https://www3dev.wipo.int/amc-forms-rest/dnda',
                    'https://www3-test.wipo.int/amc-forms-rest/dnda',
                    'https://www3.wipo.int/amc-forms-rest/dnda',
                    'https://web.amc-arbmed.arb.dev.web1.wipo.int/dnda',
                    'https://web.amc-arbmed.arb.acc.web1.wipo.int/dnda',
                    'https://web.amc-arbmed.arb.prd.web1.wipo.int/dnda',
                    'https://adr.wipo.int/dnda'
                ],
                sendAccessToken: true
            }
        })], 
    declarations: [
        AppComponent,
        RequestGoodOfficesServicesComponent,
        RequestMediationComponent, 
        ExpertDeterminationComponent,
        UnilateralRequestMediationComponent, 
        UnilateralExpertDeterminationComponent,
        RequestArbitrationComponent,
        ExpeditedArbitrationComponent,
        AdrYoungRegistrationComponent,
        WipoMcstDecisionTreeComponent,
        WipoMcstIncludeDisputeRsltComponent,
        WipoMcstIncludeDisputeRelatedContractComponent,
        LoaderComponent,
        HomeComponent,
        ContractComponent,
        PageNotFoundComponent,
        NoticeOfUnauthorizedUseComponent
    ],
    providers: [
        //  {
        //    provide: APP_BASE_HREF,
        //    useValue: environment.contextIsRoot ? '/' : '/' + (window.location.pathname.split('/')[1] || '')
        //  }, 
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: APP_INITIALIZER,
            // Intializing authentication service at the time of application start-up
            useFactory: (wipoAuthService: WipoAuthService) => () => wipoAuthService.initialize(),
            deps: [WipoAuthService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => loadNavbar,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            deps: [LoaderService],
            multi: true
        },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: 'assets/i18n/', suffix: '.json' },
    { prefix: 'assets/i18n/offices/', suffix: '.json' },
  ])
}



